import styled from "styled-components";

export const MidPinDefaultBox = styled.div`
    position: absolute;
    width: 16.67%;
    border-radius: 50%;
    box-shadow: 1px 3px 2px rgba(119, 57, 0, 0.87);
    /* filter: drop-shadow(1px 3px 2px rgba(119, 57, 0, 0.87)); */
`;
